import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class AlertValidationService {

    errResponse = { 
        "status": null,
        "error": null,
    };

    constructor(httpErrResponse: any) {
        if (httpErrResponse instanceof HttpErrorResponse) { // Angular HttpClient error response object
            this.errResponse.status = httpErrResponse.status;
            this.errResponse.error = httpErrResponse.error;
        } else if (httpErrResponse) { // Jquery Ajax error response object
            this.errResponse.status = httpErrResponse.status;
            this.errResponse.error = JSON.parse(httpErrResponse.responseText);
        }
    }

    apiValidation(btn={"elem": "", "name": ""}) {
        if (this.errResponse.status === 400) {
            let errorMessageStr = "";
            if ("released_instacredit_ref" in this.errResponse.error) 
            {
                this.errResponse.error.released_instacredit_ref.forEach(errMsg => { 
                    errorMessageStr += errMsg + "\n";
                })
            }
            if("errors" in this.errResponse.error){
                this.errResponse.error.errors.forEach(errMsg => { 
                    if("reference_number" in errMsg){
                        errorMessageStr += "Reference Number: ";
                        errMsg["reference_number"].forEach(serializer_error => {
                            errorMessageStr += serializer_error +" ";
                        })
                    }
                })
            }
            alert("Warning:\n" + errorMessageStr);
        }
        $(btn.elem).prop('disabled', false).text(btn.name);
    }
}



// WEBPACK FOOTER //
// /opt/sss_web/sss_web/src/app/service/alert-validation.service.ts